const general = {
  name: {
    presence: {
      allowEmpty: false,
      message: "Nome do produto é obrigatório."
    },
    length: {
      maximum: 60,
      message: "Nome do produto não pode ter mais de 60 caracteres."
    }
  },
  code: {
    presence: false,
    length: {
      maximum: 40,
      message: "Código não pode ter mais de 40 caracteres."
    }
  }
};

const monetization = {
  sell_value: {
    presence: {
      allowEmpty: false,
      message: "Preço de venda é obrigatório."
    },
    numericality: {
      greaterThan: 0,
      message: "Preço de venda deve ser maior que zero."
    }
  }
};

const taxes = {
  "taxes.cfop": {
    format: {
      pattern: /^(\s*|5000|5100|5101|5102|5103|5104|5105|5106|5107|5108|5109|5110|5111|5112|5113|5114|5115|5116|5117|5118|5119|5120|5122|5123|5124|5125|5150|5151|5152|5153|5154|5155|5156|5200|5201|5202|5203|5204|5205|5206|5207|5208|5209|5210|5250|5251|5252|5253|5254|5255|5256|5257|5258|5300|5301|5302|5303|5304|5305|5306|5307|5350|5351|5352|5353|5354|5355|5356|5357|5359|5360|5400|5401|5402|5403|5404|5405|5408|5409|5410|5411|5412|5413|5414|5415|5450|5451|5500|5501|5502|5503|5504|5505|5550|5551|5552|5553|5554|5555|5556|5557|5600|5601|5602|5603|5604|5605|5606|5651|5652|5653|5654|5655|5656|5657|5658|5659|5660|5661|5662|5663|5664|5665|5666|5900|5901|5902|5903|5904|5905|5906|5907|5908|5909|5910|5911|5912|5913|5914|5915|5916|5917|5918|5919|5920|5921|5922|5923|5924|5925|5926|5927|5928|5929|5931|5932|5933|5949|6000|6100|6101|6102|6103|6104|6105|6106|6107|6108|6109|6110|6111|6112|6113|6114|6115|6116|6117|6118|6119|6120|6121|6122|6123|6124|6125|6150|6151|6152|6153|6154|6155|6156|6200|6201|6202|6203|6204|6205|6206|6207|6208|6209|6210|6250|6251|6252|6253|6254|6255|6256|6257|6258|6300|6301|6302|6303|6304|6305|6306|6307|6350|6351|6352|6353|6354|6355|6356|6357|6359|6400|6401|6402|6403|6404|6408|6409|6410|6411|6412|6413|6414|6415|6500|6501|6502|6503|6504|6505|6550|6551|6552|6553|6554|6555|6556|6557|6600|6603|6651|6652|6653|6654|6655|6656|6657|6658|6659|6660|6661|6662|6663|6664|6665|6666|6900|6901|6902|6903|6904|6905|6906|6907|6908|6909|6910|6911|6912|6913|6914|6915|6916|6917|6918|6919|6920|6921|6922|6923|6924|6925|6929|6931|6932|6933|6949|7000|7100|7101|7102|7103|7104|7105|7106|7127|7200|7201|7202|7203|7204|7205|7206|7207|7210|7211|7250|7251|7300|7301|7350|7358|7500|7501|7550|7551|7553|7556|7651|7654|7900|7930|7949)$/,
      message: "CFOP inválido. Deve ser vazio ou conter um valor válido."
    }
  },
  "taxes.ncm": {
    format: {
      pattern: /^(\s*|\d{8})$/,
      message: "NCM inválido. Deve ser vazio ou conter um valor válido."
    }
  },
  "taxes.cest": {
    format: {
      pattern: /^(\s*|\d{7})$/,
      message: "CEST inválido. Deve ser vazio ou conter um valor válido."
    }
  },
  "taxes.csosn": {
    format: {
      pattern: /^(\s*|101|102|103|201|202|203|300|400|500|900)$/,
      message: "CSOSN inválido. Deve ser vazio ou conter um valor válido."
    }
  }
};

const add = {
  ...general,
  ...monetization,
  ...taxes
};

const sku = {
  ...general,
  ...monetization
};

const edit = {
  ...add,
  cost_value: {
    presence: false
  }
};

export default {
  general,
  monetization,
  taxes,
  add,
  edit,
  sku
};



// WEBPACK FOOTER //
// ./src/core/constraint/product.constraint.js